var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-overview"},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.nameTab)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }